const colors = {
  primary: "#0D3C96",
  attention: "#ff0014",
  complement: "#D2DAE8",
  deep: "#001A4D",
}

export default colors
